import {inject, Injectable} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {BehaviorSubject} from 'rxjs';

export interface AuthUser {
  userId: string;
  email: string;
  name: string;
  token: string;
}

@Injectable({providedIn: 'root'})
export class AppAuthService {
  private oidcService = inject(OidcSecurityService);
  private userSubject = new BehaviorSubject<AuthUser | undefined>(undefined);

  user$ = this.userSubject.asObservable();
  user?: AuthUser;

  constructor() {
    // Delay subscription to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => this.initAuth());
  }

  private initAuth() {
    this.oidcService.checkAuth().subscribe(({isAuthenticated, userData, accessToken}) => {
      if (isAuthenticated && accessToken && userData) {
        this.user = {
          userId: userData.sub || '',
          email: userData.email || '',
          name: userData.name || userData.email || '',
          token: accessToken
        };
        this.userSubject.next(this.user);
      } else {
        this.user = undefined;
        this.userSubject.next(undefined);
      }
    });
  }
}
